export default __webpack_public_path__ + "carrousel_sign.58885b7.png";